import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { Row, Col } from 'react-flexbox-grid';
import { Link } from 'react-router';
import { connect } from 'react-redux';

import Alert from 'antd/lib/alert';
import Icon from 'antd/lib/icon';

import {
  selectNextUnsignedContract,
  selectUnsignedContracts,
  selectPendingContracts,
  fetchPendingContractsActions,
  fetchUnsignedContractsActions,
  selectAccountId,
  fetchMeActions,
  selectAccountRegistrationStatus,
  selectToken,
} from '../../../../features/auth/ducks';

import {
  selectLoans,
  fetchLoansActions,
} from '../../../../features/loans/ducks';

import {
  selectContracts as selectAccountContracts,
} from '../../../documents/ducks';

import PendingActionAlert from '../../../../features/dashboard/components/PendingActionAlert';

import {
  debtorRegistrationActions,
  debtorRegistrationActionsT,
  creditorRegistrationActions,
  creditorRegistrationActionsT,
  accountRoles,
  contractStatus,
  contractType,
  loanActions,
  loanActionsT,
  loanStatus,
  allocationActionsT,
  accountRegistrationStatuses,
} from '../../../../common/enums';
import ConfirmContract from './ConfirmContract';
import SignContract from './SignContract';
import { bindActionCreators } from 'redux';
import SignContractDebtor from './SignContractDebtor';
import SignInvestorInfoObligationsBlock from './SignInvestorInfoObligationsBlock';
import SignInfoObligationsBlock from '../../../loans/components/SignInfoObligationsBlock';
import {
  canShowInvestorInfoObligations,
  getInvestorInfoObligationsContract,
} from './investorInfoObligationsVisibility';
import { InvestorGeneralContractAction } from './investorGeneralContractAction';

const activeActions = [
  loanActions.SIGN_CONTRACT,
  loanActions.ENTER_SMS_CODE_CONTRACT,
  loanActions.SIGN_INSURANCE_CONTRACT,
  loanActions.UPLOAD_BANK_ACCOUNT_STATEMENTS,
  loanActions.SIGN_INFO_OBLIGATIONS,
  loanActions.ENTER_SMS_CODE_INFO_OBLIGATIONS,
];

const mapStateToProps = state => ({
  accountId: selectAccountId(state),
  contract: selectNextUnsignedContract(state),
  unsignedContracts: selectUnsignedContracts(state),
  pendingContracts: selectPendingContracts(state),
  accountContracts: selectAccountContracts(state),
  loans: selectLoans(state),
  registrationStatus: selectAccountRegistrationStatus(state),
  token: selectToken(state),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    fetchPendingContracts: fetchPendingContractsActions.request,
    fetchUnsignedContracts: fetchUnsignedContractsActions.request,
    fetchLoans: fetchLoansActions.request,
    fetchMe: fetchMeActions.request,
  },
  dispatch
  )
})

@connect(mapStateToProps, mapDispatchToProps)
@translate()
export default class SignPendingContracts extends Component {
  static propTypes = {
    registrationAction: PropTypes.string,
    accountRole: PropTypes.string.isRequired,
    resendActivationEmail: PropTypes.func.isRequired,
    registrationDocumentsRejectReason: PropTypes.string,
    contract: PropTypes.object,
    insuranceContract: PropTypes.object,
    accountContracts: PropTypes.array.isRequired,
    t: PropTypes.func.isRequired,
    registrationStatus: PropTypes.string,
  };

  onRefresh = () => {
    window.location.reload();
  };

  componentDidMount() {
    const { actions, accountId } = this.props;
    actions.fetchPendingContracts({ accountId });
    actions.fetchUnsignedContracts({ accountId });

    actions.fetchLoans({
      append: false,
      options: {},
    });

    this._handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        const { registrationStatus } = this.props;
        actions.fetchLoans({ append: false, options: {} });
        if (registrationStatus === accountRegistrationStatuses.DOCUMENTS_SUBMITTED) {
          actions.fetchMe({ accountId });
        }
      }
    };
    document.addEventListener('visibilitychange', this._handleVisibilityChange);

    this._pollInterval = setInterval(() => {
      const { registrationStatus } = this.props;
      if (registrationStatus === accountRegistrationStatuses.DOCUMENTS_SUBMITTED) {
        actions.fetchLoans({ append: false, options: {} });
        actions.fetchMe({ accountId });
      }
    }, 60000);
  }

  componentWillUnmount() {
    document.removeEventListener('visibilitychange', this._handleVisibilityChange);
    clearInterval(this._pollInterval);
  }

  renderDescription() {
    return this.props.accountRole === accountRoles.DEBTOR
      ? this.renderDebtorDescription()
      : this.renderCreditorDescription();
  }

  renderSignContract() {
    return this.props.accountRole === accountRoles.DEBTOR
      ? this.renderDebtorSignContract()
      : this.renderCreditorSignContract();
  }

  getInvestorInfoObligationsContract() {
    const { unsignedContracts, pendingContracts, accountContracts } = this.props;
    return getInvestorInfoObligationsContract({
      unsignedContracts,
      pendingContracts,
      accountContracts,
    });
  }

  canShowInvestorInfoObligations() {
    return canShowInvestorInfoObligations(
      this.props.registrationStatus,
      this.getInvestorInfoObligationsContract()
    );
  }

  renderActivationEmailMessage(message) {
    const { t, resendActivationEmail } = this.props;

    return (
      <div className="registration-action-alert">
        <p>{message}</p>
        <span>
          <Link onClick={resendActivationEmail}>{t('Znova poslať aktivačný e-mail')}</Link>
          <Icon type="caret-right" />
        </span>
      </div>
    );
  }

  renderUploadDocumentsMessage(message) {
    return (
      <div>
        <div className="registration-action-alert">
          <p>{message}</p>
        </div>
      </div>
    );
  }

  renderRejectReasonMessage(message) {
    const { t } = this.props;

    return (
      <div className="registration-action-alert">
        { 
          this.props.registrationStatus === accountRegistrationStatuses.DOCUMENTS_INCORRECT ? 
            <Fragment>
              <p>Vaše dokumenty boli zamietnuté z tohto dôvodu: {message}</p>
              <p>Prosím nahrajte ich znova.</p>
            </Fragment>
           : <Fragment> 
              {
                this.props.accountRole === accountRoles.DEBTOR ?
                  <p>Vašu žiadosť o pôžičku musíme zamietnuť z tohto dôvodu: {message}</p> :
                  <p>Vašu žiadosť musíme zamietnuť z tohto dôvodu: {message}</p>
              }
              <span>
                {t('Pre viac informácií kontaktujte našu zákaznícku podporu.')}
              </span>
            </Fragment>
        }
      </div>
    );
  }

  renderDebtorDescription() {
    const { registrationAction, contract, registrationDocumentsRejectReason, loans, registrationStatus } = this.props;

    if (registrationStatus === accountRegistrationStatuses.DOCUMENTS_SUBMITTED) {
      return (
        <div>
          {'Doklady čakajú na schválenie. Po ich schválení budete môcť pokračovať v podpise Informačných povinností klienta.'}
        </div>
      );
    }

    const infoObligationsLoan = this.getInfoObligationsLoan(loans);
    if (infoObligationsLoan) {
      return loanActionsT[this.getInfoObligationsAction(infoObligationsLoan)];
    }

    const message = debtorRegistrationActionsT[registrationAction];

    switch (registrationAction) {
      // case debtorRegistrationActions.CONFIRM_EMAIL:
      //   return this.renderActivationEmailMessage(message);

      case debtorRegistrationActions.DOCUMENTS_REJECTED:
        return this.renderRejectReasonMessage(registrationDocumentsRejectReason);

      case debtorRegistrationActions.PRESCORING_FAILED:
        return <div>{ message }</div>

      case debtorRegistrationActions.UPLOAD_DOCUMENTS:
        return registrationDocumentsRejectReason
          ? this.renderRejectReasonMessage(registrationDocumentsRejectReason)
          : this.renderUploadDocumentsMessage(message);

      case debtorRegistrationActions.UPLOAD_BANK_ACCOUNT_STATEMENTS:
        return null;

      case debtorRegistrationActions.SIGN_CONTRACT:
        let text = debtorRegistrationActionsT[debtorRegistrationActions.SIGN_ALL_CONTRACTS];

        return (
          <div>
            <Link>
                {text}
            </Link>
          </div>
        );
      case debtorRegistrationActions.ENTER_SMS_CODE_CONTRACT:
        let textMessage = debtorRegistrationActionsT.ENTER_SMS_CODE_CONTRACT

        return (
          <ConfirmContract confirmBy="smsCode">
            <Link>{textMessage}</Link>
          </ConfirmContract>
        );
      case debtorRegistrationActions.WAIT_FOR_DOCUMENT_CONFIRMATION:
        return (
          <div onClick={this.onRefresh} style={{ cursor: 'pointer' }}>
            {`${message} `}
          </div>
        );
      case debtorRegistrationActions.GENERAL_CONTRACT_SIGN:
        text = '';
        
        if (contract && contract.type === contractType.GENERAL) {
          text = message
        } else {
          text = loanActionsT.SIGN_CONTRACT
        }

        return (
          <div>
            <Link>
              {text}
            </Link>
          </div>
        );
      default:
        return message;
    }
  }

  renderDebtorSignContract() {
    const { registrationAction, unsignedContracts, loans } = this.props;
    const infoObligationsLoan = this.getInfoObligationsLoan(loans);

    if (infoObligationsLoan) {
      return (
        <div className="registration-action-alert">
          <SignInfoObligationsBlock
            loan={infoObligationsLoan}
            initialPhase={
              this.isInfoObligationsPending(infoObligationsLoan)
                ? 'confirm'
                : undefined
            }
          />
        </div>
      );
    }

    const pendingLoan = loans.find(loan =>
      loan.action === loanActions.SIGN_CONTRACT ||
      loan.action === loanActions.ENTER_SMS_CODE_CONTRACT ||
      loan.action === loanActions.UPLOAD_BANK_ACCOUNT_STATEMENTS
    );
    const isPendingLoanSms = pendingLoan && pendingLoan.action === loanActions.ENTER_SMS_CODE_CONTRACT;

    if (
      pendingLoan && pendingLoan.action === loanActions.UPLOAD_BANK_ACCOUNT_STATEMENTS
    ) {
      return null;
    }

    if (unsignedContracts.length == 0 && !isPendingLoanSms) {
      return null;
    }

    if (
      registrationAction === debtorRegistrationActions.SIGN_CONTRACT 
      || registrationAction === debtorRegistrationActions.GENERAL_CONTRACT_SIGN
      || (!registrationAction && (unsignedContracts.length > 0 || isPendingLoanSms))
    ) {
      return (<SignContractDebtor pendingLoan={pendingLoan}/>);
    }
  }

  renderCreditorSignContract() {
    if (!this.canShowInvestorInfoObligations()) {
      return null;
    }

    return <SignInvestorInfoObligationsBlock />;
  }

  renderInvestorGeneralContractAction(contract) {
    const { t, token } = this.props;

    return (
      <InvestorGeneralContractAction
        contract={contract}
        token={token}
        t={t}
        SignContractComponent={SignContract}
      />
    );
  }

  getInfoObligationsLoan(loans) {
    const SIGNABLE = [
      accountRegistrationStatuses.ACCOUNT_ACTIVE,
      accountRegistrationStatuses.BANK_ACCOUNT_STATEMENTS_UPLOADED,
      accountRegistrationStatuses.NEW_GENERAL_CONTRACT,
    ];
    const isSignable = SIGNABLE.includes(this.props.registrationStatus);

    const byAction = loans.find(loan =>
      loan.action === loanActions.SIGN_INFO_OBLIGATIONS ||
      loan.action === loanActions.ENTER_SMS_CODE_INFO_OBLIGATIONS
    );
    if (byAction) return byAction;
    if (!isSignable) return null;
    return loans.find(loan => this.hasUnsignedInfoObligationsContract(loan)) || null;
  }

  getInfoObligationsContract(loan) {
    if (loan.infoObligationsPending) {
      return {
        type: contractType.INFORMATION_OBLIGATIONS_DEBTOR,
        id: loan.infoObligationsPending.contractId,
        fileId: loan.infoObligationsPending.fileId,
        status: loan.infoObligationsPending.status || contractStatus.INACTIVE,
      };
    }

    return loan.contracts
      ? loan.contracts.find(c => c.type === contractType.INFORMATION_OBLIGATIONS_DEBTOR)
      : null;
  }

  hasUnsignedInfoObligationsContract(loan) {
    const infoContract = this.getInfoObligationsContract(loan);
    return loan.status === loanStatus.NPI &&
      infoContract &&
      infoContract.status !== contractStatus.CONFIRMED;
  }

  getInfoObligationsAction(loan) {
    if (
      loan.action === loanActions.SIGN_INFO_OBLIGATIONS ||
      loan.action === loanActions.ENTER_SMS_CODE_INFO_OBLIGATIONS
    ) {
      return loan.action;
    }

    return this.isInfoObligationsPending(loan)
      ? loanActions.ENTER_SMS_CODE_INFO_OBLIGATIONS
      : loanActions.SIGN_INFO_OBLIGATIONS;
  }

  isInfoObligationsPending(loan) {
    const infoContract = this.getInfoObligationsContract(loan);
    return loan.action === loanActions.ENTER_SMS_CODE_INFO_OBLIGATIONS ||
      (infoContract && infoContract.status === contractStatus.PENDING_CONFIRMATION);
  }

  renderCreditorDescription() {
    const { registrationAction, registrationDocumentsRejectReason, contract, registrationStatus, t } = this.props;
    const investorInfoObligations = this.getInvestorInfoObligationsContract();

    if (canShowInvestorInfoObligations(registrationStatus, investorInfoObligations)) {
      return investorInfoObligations.status === contractStatus.PENDING_CONFIRMATION
        ? t('Zadajte SMS kód pre potvrdenie Informačných povinností poskytovateľa služieb')
        : t('Pred pokračovaním je potrebné podpísať Informačné povinnosti poskytovateľa služieb.');
    }

    if (
      registrationStatus === accountRegistrationStatuses.DOCUMENTS_ACCEPTED &&
      contract &&
      contract.type === contractType.GENERAL
    ) {
      return this.renderInvestorGeneralContractAction(contract);
    }

    const message = creditorRegistrationActionsT[registrationAction];

    switch (registrationAction) {
      case creditorRegistrationActions.CONFIRM_EMAIL:
        return this.renderActivationEmailMessage(message);
      case creditorRegistrationActions.UPDATE_PROFILE:
        return <Link to="dashboard/personal-info">{message}</Link>;
      case creditorRegistrationActions.UPLOAD_DOCUMENTS:
        return registrationDocumentsRejectReason ? (
          this.renderRejectReasonMessage(registrationDocumentsRejectReason)
        ) : (
            <Link to="dashboard/documents">{message}</Link>
          );
      case creditorRegistrationActions.SIGN_CONTRACT:
        return (
          <SignContract>
            <Link>{message}</Link>
          </SignContract>
        );
      case creditorRegistrationActions.ENTER_SMS_CODE_CONTRACT:
        return (
          <ConfirmContract confirmBy="smsCode">
            <Link>{message}</Link>
          </ConfirmContract>
        );
      case creditorRegistrationActions.GENERAL_CONTRACT_SIGN:
        return (
          <SignContract>
            <Link>
              {contract && contract.type === contractType.GENERAL
                ? message
                : allocationActionsT.SIGN_CONTRACT}
            </Link>
          </SignContract>
        );
      default:
        return message;
    }
  }

  render() {
    const { registrationAction, unsignedContracts, pendingContracts, loans } = this.props;
    const showInvestorInfoObligations = this.canShowInvestorInfoObligations();

    const pendingActions = loans.filter(loan =>
      activeActions.includes(loan.action) ||
      this.hasUnsignedInfoObligationsContract(loan)
    ).length;


    if (!registrationAction && !unsignedContracts.length && !pendingContracts.length && !pendingActions) {
      return <div />;
    }

    return (
      <div>
        <PendingActionAlert pendingActions={pendingActions} />
        {
          registrationAction && 
          !showInvestorInfoObligations &&
          !(this.props.accountRole === accountRoles.DEBTOR 
            && registrationAction === debtorRegistrationActions.UPLOAD_BANK_ACCOUNT_STATEMENTS) && (
            <Row around="xs">
              <Col xs={12}>
                <Alert
                  message={this.renderDescription()}
                  type="warning"
                  showIcon
                  description={'\t'}
                />
              </Col>
            </Row>
          )
        }
        {this.renderSignContract()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/dashboard/components/registration-action-alert/SignPendingContracts.js